import { NgModule } from '@angular/core';

// components & directives
import { AppComponent } from './app.component';

// services
import { AwsEnvironment, createAwsEnv } from './aws/environment';
import { AuthGuard } from './router/auth-guard.service';

// modules
import { BrowserModule } from '@angular/platform-browser';
import { AppRouterModule } from './router/routes';
import { AwsModule } from './aws/aws.module';
import { PublisherModule } from './publisher/publisher.module';
import { ProgressModule } from './progress/progress.module';
import { HeaderFooterModule } from './headerfooter/headerfooter.module';
import { LoginModule } from './login/login.module';
import { MainModule } from './main/main.module';
import { MQTTModule } from './mqtt/mqtt.module';
import { RestApiModule } from './restapi/restapi.module';
import { UserModule } from './user/user.module';
import { PipesModule } from './pipes/pipes.module';
import { LicensingModule } from './licensing/licensing.module';
import { TreeModule } from './tree/tree.module';
import {FormsModule} from '@angular/forms';
import {TrialComponent} from './trial/trial.component';
import {TrialService} from './trial/trial.service';
import {TrialAuthGuardService} from './router/trial-auth-guard.service';
import {ModalService} from './modals/modal.service';
import {ModalsModule} from './modals/modals.module';
import {EqualValidator} from './components/equal-validator.directive';
import {TOSEntry} from './headerfooter/setting-entries/tos-entry';
import {TooSimilarDirective} from './components/too-similar.directive';
import {ValidateOnBlur} from './trial/trial.component';
import {ReleaseNotesComponent} from './release-notes/release-notes.component';


@NgModule({
    imports: [
        BrowserModule,
        AppRouterModule,
        AwsModule,
        HeaderFooterModule,
        LoginModule,
        MainModule,
        MQTTModule,
        ProgressModule,
        PublisherModule,
        RestApiModule,
        UserModule,
        PipesModule,
        LicensingModule,
        TreeModule,
        FormsModule,
        ModalsModule
    ],

    declarations: [
        AppComponent,
        TrialComponent,
        EqualValidator,
        TooSimilarDirective,
        ValidateOnBlur,
        ReleaseNotesComponent
    ],

    bootstrap: [AppComponent],

    providers: [
        { provide: AwsEnvironment, useFactory: createAwsEnv },
        AuthGuard,
        TrialAuthGuardService,
        TrialService,
        TOSEntry
    ]
})
export class AppModule { }


// WEBPACK FOOTER //
// ./src/app/app.module.ts